var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_740_8465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_740_8465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30775 20.5C6.81058 20.5 6.385 20.323 6.031 19.969C5.677 19.615 5.5 19.1894 5.5 18.6923V6H5.25C5.0375 6 4.85942 5.92808 4.71575 5.78425C4.57192 5.64042 4.5 5.46225 4.5 5.24975C4.5 5.03708 4.57192 4.859 4.71575 4.7155C4.85942 4.57183 5.0375 4.5 5.25 4.5H9C9 4.25517 9.08625 4.0465 9.25875 3.874C9.43108 3.70167 9.63967 3.6155 9.8845 3.6155H14.1155C14.3603 3.6155 14.5689 3.70167 14.7413 3.874C14.9138 4.0465 15 4.25517 15 4.5H18.75C18.9625 4.5 19.1406 4.57192 19.2843 4.71575C19.4281 4.85959 19.5 5.03775 19.5 5.25025C19.5 5.46292 19.4281 5.641 19.2843 5.7845C19.1406 5.92817 18.9625 6 18.75 6H18.5V18.6923C18.5 19.1894 18.323 19.615 17.969 19.969C17.615 20.323 17.1894 20.5 16.6923 20.5H7.30775ZM10.1543 17C10.3668 17 10.5448 16.9282 10.6885 16.7845C10.832 16.6407 10.9037 16.4625 10.9037 16.25V8.75C10.9037 8.5375 10.8318 8.35933 10.688 8.2155C10.5443 8.07183 10.3662 8 10.1535 8C9.941 8 9.76292 8.07183 9.61925 8.2155C9.47575 8.35933 9.404 8.5375 9.404 8.75V16.25C9.404 16.4625 9.47583 16.6407 9.6195 16.7845C9.76333 16.9282 9.94158 17 10.1543 17ZM13.8465 17C14.059 17 14.2371 16.9282 14.3807 16.7845C14.5243 16.6407 14.596 16.4625 14.596 16.25V8.75C14.596 8.5375 14.5242 8.35933 14.3805 8.2155C14.2367 8.07183 14.0584 8 13.8458 8C13.6333 8 13.4552 8.07183 13.3115 8.2155C13.168 8.35933 13.0962 8.5375 13.0962 8.75V16.25C13.0962 16.4625 13.1682 16.6407 13.312 16.7845C13.4557 16.9282 13.6338 17 13.8465 17Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ca82d8766e6022162c9a04515555d767.svg";
export { ForwardRef as ReactComponent };